import { apiFields } from "./_utils";

export const createActiveClassroomWindowStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: {},
	classroomExpiry: { classroomId: null, expiry: null },

	setData: (newWindowData) => {
		setIn({ data: newWindowData });
	},

	IsUserPlatformAgentOnly: (username) => {
		if (!username) {
			return false;
		}

		const currentWindowData = get().activeClassroomWindow.data;

		const selectedUser = currentWindowData[username];

		// dont show notice if there is no window data
		if (!selectedUser) {
			return false;
		}

		if (selectedUser && !selectedUser.screenshots.length) {
			return false;
		}

		if (selectedUser && selectedUser.screenshots) {
			// check against array of screenshots to see if a chrome platform exists
			for (const windowData of selectedUser.screenshots) {
				// no platform_type or empty string means it is non agent (based on existing behaviour at time of writing)
				if (!windowData.platform_type || windowData.platform_type.length === 0) {
					return false;
				}

				if (windowData.platform_type && windowData.platform_type === "chrome") {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * @param {string} classroomId
	 * @param {number} expiry
	 */
	setClassroomExpiry: (classroomId, expiry) => {
		setIn({ classroomExpiry: { classroomId: classroomId, expiry: expiry } });
	},

	getStudents: () => {
		return get().activeClassroomWindow.data;
	},
});
